import {
	postRequest,
	getRequest,
	putRequest,
	deleteRequest,
	getRequests
} from "./http.js"
//登录
// export const Login = data =>{ //登录
// 	return postRequest('login/login',data)
// }
//首页
let Api = {
	login: (data) => { //登录
		return postRequest('login/login', data)
	},
	
	captcha: (data) => { //获取验证码
		return postRequest('login/captcha', data)
	},
	register:(data)=>{  //注册
		return postRequest('login/register',data)
	},
	wxGetUrl:(data)=>{ //微信登录
		return  postRequest('login/wxGetUrl',data)
	},	
	lwxCallBack:(data)=>{  //微信回调
			return postRequest("login/wxCallBack",data)
	},
	getCity: (data) => { //获取城市信息
		return postRequest('public/city', data)
	},
	updateImg: (data) => { //修改用户头像 
		return postRequest('user/updateImg', data)
	},
	updateNickname: (data) => { //获取用户昵称
		return postRequest('user/updateNickname', data)
	},
	getCateVice: (data) => { // 获取科目
		return postRequest('public/getCateVice', data)
	},
	getMobileCode: (data) => { // 获取短信验证码
		return postRequest('login/getMobileCode', data)
	},
	userForgoPassword: (data) => { // 修改密码
		return postRequest('login/userForgoPassword', data)
	},
	getUserNote: (data) => { // 获取用户笔记
		return postRequest('user/getUserNote', data)
	},
 delUserNote:(data)=>{ //删除用户笔记
	 return postRequest('user/delUserNote',data)
 },
	getUserCollect: (data) => { // 获取我的收藏
		return postRequest('user/getUserCollect', data)
	},
	getWrongExam: (data) => { // 获取用户错题
		return postRequest('user/getWrongExam', data)
	},
	getUserInfo: (data) => { // 获取用户详情
		return postRequest('user/getUserInfo', data)
	},

	getCate: (data) => { // 选择类型
		return postRequest('public/getCate', data)
	},
	getCateVice: (data) => { // 选择学科
		return postRequest('public/getCateVice', data)
	},
	GetPieceData: (data) => { // 专项训练分类接口
		return postRequest('exam/GetPieceData', data)
	},
	getChapterData: (data) => { // 首页篇章节
		return postRequest('exam/getChapterData', data)
	},
	getQuesList: (data) => { // 首页篇章节
		return postRequest('exam/getQuesList', data)
	},
	getCategoryData: (data) => { // 分类数据统计接口
		return postRequest('user/getCategoryData', data)
	},
	getQuesExam: (data) => { // 获取试卷接口
		return postRequest('exam/getQuesExam', data)
	},
	submitAnswer: (data) => { // 试卷提交接口
		return postRequest('exam/submitAnswer', data)
	},

	getAnswerResult: (data) => { // 获取答题结果
		return postRequest('exam/getAnswerResult', data)
	},
	getAnswerAnalysis: (data) => { // 获取答题解析
		return postRequest('exam/getAnswerAnalysis', data)
	},
	getPageNote: (data) => { // 获取笔记
		return postRequest('exam/getPageNote', data)
	},
	setUserNote: (data) => { // 获取笔记
		return postRequest('exam/setUserNote', data)
	},
	setCorrection: (data) => { // 获取笔记
		return postRequest('exam/setCorrection', data)
	},
	setUserCollect: (data) => { // 添加和取消收藏
		return postRequest('exam/setUserCollect', data)
	},
	getSpecialExam: (data) => { // 获取专项,随机试题接口
		return postRequest('exam/getSpecialExam', data)
	},
	resetAnswer: (data) => { // 专项练习重置
		return postRequest('exam/resetAnswer', data)
	},
	getWrongInfo: (data) => { // 错题巩固
		return postRequest('user/getWrongInfo', data)
	},
	getUserCollectList: (data) => { // 我的收藏
		return postRequest('user/getUserCollectList', data)
	},
	getUserExam: (data) => { // 我的收藏
		return postRequest('user/getUserExam', data)
	},
	wrongRecall: (data) => { // 巩固记忆错题
		return postRequest('user/wrongRecall', data)
	},

	searchAnswer: (data) => { // 试题搜索
		return postRequest('exam/searchAnswer', data)
	},

	getSearchAnswer: (data) => { // 试题搜索详情
		return postRequest('exam/getSearchAnswer', data)
	},
	getPoster:(data) =>{  //获取轮播图片
		return postRequest("exam/getPoster",data)
	},
	wxBind:(data)=>{ //微信绑定电话
		 return postRequest("login/wxBind",data)
	},
	qqGetUrl:(data)=>{ //qq登录
		return postRequest('login/qqGetUrl',data)
	},
	qqCallBack:(data)=>{  //qq登录回调
		return postRequest('login/qqCallBack',data)
	},
	qqBind:(data)=>{  //qq绑定电话
		return postRequest('login/qqBind',data)
	},
	userNotePraise:(data)=>{  //点赞
		return postRequest('/user/userNotePraise',data)
	},
	searchList:(data)=>{  //搜索页面数据
			return postRequest('exam/searchList',data)
	},
	getipcy:(data)=>{
		//console.log(data)
		return getRequests('/get_ip_location?ip='+data.ip)
	}
}
export default {
	Api
}
